import './features.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  $('.features__item').click(function () {
    $('.features__item--active').removeClass('features__item--active');
    $(this).addClass('features__item--active');
    const data = {
      image: $(this).data('image')
    };
    $('.features__ipad-img').css('background-image', `url(${data.image})`);
    if ($(window).width() <= 768) {
      $('html, body').animate({ scrollTop: $('.features__ipad').offset().top - 80 }, 250);
    }
  });
});